import styled, { css } from 'styled-components';

export const handleColorType = (props) => {
	switch (props?.color) {
		case 'blue':
			return props.theme.colors.primary;
		case 'green':
			return props.theme.colors.YellowGreen;
		case 'red':
			return props.theme.colors.SizzlingRed;
		case 'orange':
			return props.theme.colors.YellowOrange;
		case 'red-border':
			return 'transparent';
		default:
			return '#000';
	}
};

export const ColorRound = styled.div`
	height: 10px;
	width: 10px;
	border-radius: 5px;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	margin: 0 5px 5px 5px;
	background-color: ${(props) => handleColorType(props)};
	${(props) =>
		props.chosenColor &&
		css`
			outline: 0.1rem solid ${() => handleColorType(props)};
		`}
	outline-offset: 0.2rem;
	${(props) =>
		props.color === 'red-border' &&
		css`
			border: 2px solid ${props.theme.colors.SizzlingRed};
		`}
`;
